import { HeadCount, useWizard } from '@insify/funnel-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCommands } from '../../hooks/useCommands';
import { useContent } from '../../hooks/useContent';
import { useParamsQuery } from '../../hooks/useQueries';

import type { HeadcountFormType } from '@insify/funnel-components';
import type { SubmitHandler } from 'react-hook-form';

export function HeadCountPage(): JSX.Element | null {
  const { showPreviousPage, showNextPage } = useWizard();
  const { t } = useTranslation(['common', 'validation']);
  const { quoteWizardHeadcount } = useContent() || {};
  const { sendCommand } = useCommands();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [triggerShowingNextPage, setTriggerShowingNextPage] = useState(false);
  const { isStale, data = {} } = useParamsQuery();

  const handleCommand: SubmitHandler<HeadcountFormType> = async ({ headCount }) => {
    setIsSubmitting(true);
    await sendCommand({
      type: 'enterHeadCount',
      payload: {
        headCount: Number(headCount),
      },
    });
    setTriggerShowingNextPage(true);
  };

  useEffect(() => {
    if (triggerShowingNextPage && !isStale && data?.headCount) {
      showNextPage();
      setTriggerShowingNextPage(false);
    }
  }, [triggerShowingNextPage, isStale, data]);

  return (
    <HeadCount
      formData={data}
      eventHandlers={{
        onSubmit: handleCommand,
        onBack: showPreviousPage,
      }}
      content={quoteWizardHeadcount}
      translations={{
        back: t('common:back'),
        forward: t('common:continue'),
        validation: {
          integer: t('validation:number_must_be_integer'),
          required: t('validation:headcount_required'),
          min: t('validation:headcount_not_zero'),
          max: t('validation:whoah_maybe_you_should_insure_us'),
        },
      }}
      isSubmitting={isSubmitting}
    />
  );
}
